import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { NumericValueOfNotAvailable } from '../../utils/constants';
import { PricingStatus } from '../constants';
import axios from 'axios';
import { getOrderSummaryHelper } from '../selectors';
import { getShippingChargeAsync } from '../logics';
import { updateShipping } from '../../main/actions';

const useOrderSummaryDetails = () => {
  const dispatch = useDispatch();

  const helper = useSelector(getOrderSummaryHelper);
  const { chargeDetails, discountInfo, shippingInfo, status, totalWithoutShippingCharge, validation } = helper;
  const { essentialCharge } = chargeDetails;
  const { quantity } = essentialCharge;
  const { showShippingCharge, zipCode } = shippingInfo;

  const [shippingChargeInfo, setShippingChargeInfo] = useState({
    isCalculating: false,
    isTbd: false,
    shippingCharge: NumericValueOfNotAvailable,
    zipCode,
  });

  const [totalChargeInfo, setTotalChargeInfo] = useState({
    isCalculating: false,
    totalCharge: totalWithoutShippingCharge,
  });

  useEffect(() => {
    if (!validation.isValid) return;

    const needToCalculateShippingCharge = showShippingCharge && !!zipCode;

    setShippingChargeInfo({
      isCalculating:
        needToCalculateShippingCharge && (status === PricingStatus.Loading || status === PricingStatus.Succeeded),
      isTbd: false,
      shippingCharge: NumericValueOfNotAvailable,
      zipCode,
    });

    setTotalChargeInfo({
      isCalculating:
        status === PricingStatus.Loading || (needToCalculateShippingCharge && status === PricingStatus.Succeeded),
      totalCharge: totalWithoutShippingCharge,
    });

    if (!needToCalculateShippingCharge || status !== PricingStatus.Succeeded) return;

    let mounted = true;
    const cancelTokenSource = axios.CancelToken.source();

    dispatch(
      getShippingChargeAsync(quantity, totalWithoutShippingCharge, cancelTokenSource, (responseData) => {
        if (mounted) {
          const { isCalculating, isTbd, shippingCharge, shippingMethodId } = responseData;

          dispatch(
            updateShipping({
              methodId: shippingMethodId,
            })
          );

          setShippingChargeInfo({
            isCalculating,
            isTbd,
            shippingCharge,
            zipCode,
          });

          setTotalChargeInfo({
            isCalculating,
            totalCharge:
              !isCalculating && !isTbd ? totalWithoutShippingCharge + shippingCharge : totalWithoutShippingCharge,
          });
        }
      })
    );

    return () => {
      cancelTokenSource.cancel();
      mounted = false;
    };
  }, [dispatch, quantity, showShippingCharge, status, totalWithoutShippingCharge, validation.isValid, zipCode]);

  return { chargeDetails, discountInfo, shippingChargeInfo, showShippingCharge, totalChargeInfo, validation };
};

export default useOrderSummaryDetails;
